var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { formDataLayer } from '@anwb/data-layer';
import toKebabCase from '@anwb/to-kebab-case';
import { NotificationCloseButton, NotificationContainer, NotificationContent, NotificationIcon, NotificationTitle, } from './styles/notification.styled';
const iconNameMap = {
    info: 'information',
    success: 'success',
    warning: 'warning',
    error: 'error',
    promotion: 'percentage',
};
/**
 * A notification is a component which will display a few lines of text of varying levels of importance.
 */
const Notification = (_a) => {
    var { children, variant, title, closeButton, onClose, class: className, dataTest = 'notification' } = _a, props = __rest(_a, ["children", "variant", "title", "closeButton", "onClose", "class", "dataTest"]);
    const [closed, setClosed] = useState(false);
    const closeNotification = () => {
        setClosed(true);
        if (onClose)
            onClose(true);
    };
    useEffect(() => {
        if (closed) {
            formDataLayer({
                type: 'interaction',
                category: 'components',
                action: `notification-${toKebabCase(title)}`,
                label: 'close',
            });
        }
    }, [closed, title]);
    const notificationClassNames = classNames('PONCHO-notification', className, {
        [`PONCHO-notification--${variant}`]: variant,
        [`PONCHO-notification--with-close`]: closeButton,
    });
    if (closed)
        return null;
    return (React.createElement(NotificationContainer, Object.assign({ className: notificationClassNames, "$variant": variant }, props),
        React.createElement(NotificationIcon, { className: "PONCHO-notification-icon", variant: iconNameMap[variant], dataTest: `${dataTest}-icon` }),
        React.createElement(NotificationTitle, { className: "PONCHO-notification-subtitle", dataTest: `${dataTest}-title` }, title),
        closeButton && variant !== 'error' && (React.createElement(NotificationCloseButton, { className: "PONCHO-notification__close-button", onClick: closeNotification, "data-test": `${dataTest}-close-button` })),
        React.createElement(NotificationContent, { dataTest: `${dataTest}-children` }, children)));
};
export default Notification;
//# sourceMappingURL=Notification.js.map